<template>
    <div class="w-full grid-cols-3 grid gap-2">
        <input v-if="images_to_delete.length" type="text" id="images_to_delete" name="images_to_delete" :value="JSON.stringify(images_to_delete)">
        <div v-for="(image, index) in data" :key="index"
            class="bg-gray-100 rounded-md border border-gray-300 basis-1/3 flex justify-center items-center relative animate-in fade-in">
            <div class="w-full h-56 relative">
                <file_input_preview id='image' :nr="index" :currentvalue="image.url"
                    accept="image/png, image/jpeg, image/jpg, image/webp">
                </file_input_preview>

                <div @click="removeItem(index, image)"
                    class="w-5 h-5 absolute text-xs -right-2 -top-2 rounded-full bg-gray-100 text-gray-700 border border-gray-300 flex items-center justify-center hover:scale-90 transition cursor-pointer hover:bg-gray-300 z-5">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3" fill=currentColor
                        viewBox="0 0 384 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
                        <path
                            d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
                    </svg>
                </div>
            </div>
        </div>
        <div @click="addItem" class="h-56" v-if="data.length < 9">
            <label
                class="flex flex-col items-center justify-center w-full border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 js_file_input_preview h-full w-full relative group overflow-hidden">
                <div
                    class="flex flex-col items-center justify-center pt-5 pb-6 px-4  text-gray-500 js_skeleton z-[1] w-full h-full transition pointer-events-none">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8 mb-4 transition" fill=currentColor
                        viewBox="0 0 448 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
                        <path
                            d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z" />
                    </svg>
                    <p class="text-sm"><span>Click to Add</span>
                    </p>
                </div>
            </label>
        </div>
    </div>
</template>
  
<script>
import draggable from "vuedraggable";

export default {
    components: {
        draggable,
    },
    computed: {
        dragOptions() {
            return {
                animation: 200,
                group: "description",
                disabled: false,
                ghostClass: "draggableimageghost",
            };
        },
    },
    data() {
        return {
            data: this.$attrs.data ?? [],
            drag: false,
            images_to_delete: []
        };
    },
    methods: {
        addItem(e) {
            if (this.data.length < 9) {
                this.data.push({});
            }
        },
        removeItem(index, image) {
            var item = _.cloneDeep(this.data);
            item.splice(index, 1);
            this.data = [];

            var _this = this;
            setTimeout(function () {
                _this.data = item;
            }, 1)
            this.images_to_delete.push(image.url.split("/").slice(-1)[0].split('.webp')[0]);
        },
    }
};
</script>